import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

const selectMileageDeviations = (state: RootState) =>
  state.rootReducer.mileageDeviationsReducer.mileageDeviations;

const selectMileageDeviationLoading = (state: RootState) =>
  state.rootReducer.mileageDeviationsReducer.loading;

const selectMileageDeviationUpdatingStatus = (state: RootState) =>
  state.rootReducer.mileageDeviationsReducer.updatingStatus;

const selectMileageDeviationUpdatingComment = (state: RootState) =>
  state.rootReducer.mileageDeviationsReducer.updatingComment;

export const selectTotalMileageDeviations = (state: RootState) =>
  state.rootReducer.mileageDeviationsReducer.totalMileageDeviations;

export const selectMileageDeviationState = createSelector(
  selectMileageDeviations,
  selectTotalMileageDeviations,
  selectMileageDeviationLoading,
  selectMileageDeviationUpdatingStatus,
  selectMileageDeviationUpdatingComment,
  (
    mileageDeviations,
    totalMileageDeviations,
    mileageDeviationLoading,
    updatingStatus,
    updatingComment
  ) => ({
    mileageDeviations,
    totalMileageDeviations,
    mileageDeviationLoading,
    updatingStatus,
    updatingComment
  })
);
